import { render, staticRenderFns } from "./approveDialog.vue?vue&type=template&id=a3e5cf5c&scoped=true&"
import script from "./approveDialog.vue?vue&type=script&lang=js&"
export * from "./approveDialog.vue?vue&type=script&lang=js&"
import style0 from "./approveDialog.vue?vue&type=style&index=0&id=a3e5cf5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e5cf5c",
  null
  
)

export default component.exports